<template>
  <div class="contain padc">
    <div class="layout-desc-check">
      <div class="content-desc-check">
        <div class="ele-addvisit"><span class="label-add-visit"
                style="width: 0.84rem">客户</span><input type="text"
                 placeholder="请输入客户关键字进行搜索"
                 class="text-addvisit"
                 v-model="customerName"
                 v-show="customerId==0"><span style="padding-left:0.1rem"
                v-show='customerId==0'
                @click="searchCustData"><img src="../../assets/images/icon-search.png"></span>
          <span style="padding-left:0.1rem"
                v-show='customerId!=0'>{{this.customerName}}</span>
          <van-button plain
                      type="info"
                      style="width:0.84rem;height:0.54rem;padding:0.1rem;font-size:0.24rem"
                      v-show='customerId!=0'
                      @click="changeCustomer">修改</van-button>
        </div>
        <!--元素-->
        <div class="ele-addvisit"
             v-if="this.planid==''||this.planid==undefined">
          <span class="label-add-visit">销售员</span>
          <span class="info-desc-check"
                v-if="rolePowers.indexOf(RoleType.mutiBranch)==-1">{{this.salesName}}</span>
          <input type="text"
                 v-if="rolePowers.indexOf(RoleType.mutiBranch)!=-1"
                 placeholder="请选择销售员"
                 class="text-addvisit"
                 v-model="salTxt"
                 @click="showSal"
                 readonly>
        </div>
        <!--元素-->
        <div class="ele-addvisit"
             v-if="this.planid!=''&&this.planid!=undefined">
          <span class="label-add-visit">销售员</span>
          <span class="info-desc-check">{{this.salTxt}}</span>
        </div>
        <!--元素-->
        <div class="ele-addvisit"><span class="label-add-visit">访问日期</span><input type="text"
                 placeholder="请选择访问日期"
                 class="text-addvisit"
                 v-model="visitDate"
                 @click="showCalendar(0)"
                 readonly></div>
        <!-- <div class="ele-addvisit"><span class="label-add-visit">下次访问日期</span><input type="text"
                 placeholder="请选择访问日期"
                 class="text-addvisit"
                 v-model="nextVisitDate"
                 @click="showCalendar(1)"
                 readonly></div> -->
        <div class="ele-addvisit"><span class="label-add-visit">访问原因</span><input type="text"
                 placeholder="请选择访问原因"
                 class="text-addvisit"
                 v-model="visitReasonTxt"
                 @click="showVisitReason"
                 readonly></div>
        <!--元素-->
        <div class="ele-addvisit noborderb"><span class="label-add-visit">访问方式</span>
          <input class="text-addvisit"
                 placeholder="请选择访问方式"
                 v-model="visitWayText"
                 @click="showVisitWay"
                 readonly>
        </div>
        <!--元素-->
      </div>
    </div>
    <!--模块-->
    <div class="layout-desc-check">
      <div class="tit-desc-check color-nol">主访人</div>
      <div class="content-desc-check cotent-contact-check"
           v-for="p in visiters.mainVisiterdata"
           :key="p.tempId">
        <div>
          <div class="ele-desc-check"
               @click="getConnecters(p.tempId,mainV)"><span class="label-desc-check">姓名</span><span class="info-desc-check">{{p.name}}</span></div>
          <div class="ele-desc-check"
               @click="getNextDate(p.tempId,mainV)"><span class="label-desc-check">下次访问日期</span><span class="info-desc-check">{{p.nextDate}}</span></div>
        </div>
        <div class="ele-desc-check">
          <button class="del-desc-check btnCenter"
                  @click="deleteVisiter(p.tempId,mainV)">删除</button>
        </div>
      </div>
      <div style="padding-bottom:1rem">
        <a href="#"
           class="link-add-contact"
           @click="addVisiter(mainV)"><img src="../../assets/images/icon-add.png"
               class="icons-add-contact"><span>添加主访人</span></a>
      </div>
      <!-- <div class="content-desc-check">
        <div class="ele-addvisit noborderb"><span class="label-add-visit">主访人</span>
          <input class="text-addvisit"
                 placeholder="请选择主访人姓名"
                 v-model="connecterName"
                 @click="getConnecters"
                 readonly>
        </div>
      </div> -->
    </div>
    <div class="layout-desc-check">
      <div class="tit-desc-check color-nol">随访人</div>
      <div class="content-desc-check cotent-contact-check"
           v-for="p in visiters.withVisiterdata"
           :key="p.tempId">
        <div>
          <div class="ele-desc-check"
               @click="getConnecters(p.tempId,withV)"><span class="label-desc-check">姓名</span><span class="info-desc-check">{{p.name}}</span></div>
          <div class="ele-desc-check"
               @click="getNextDate(p.tempId,withV)"><span class="label-desc-check">下次访问日期</span><span class="info-desc-check">{{p.nextDate}}</span></div>
        </div>
        <div class="ele-desc-check">
          <button class="del-desc-check btnCenter"
                  @click="deleteVisiter(p.tempId,withV)">删除</button>
        </div>
      </div>
      <div style="padding-bottom:1rem">
        <a href="#"
           class="link-add-contact"
           @click="addVisiter(withV)"><img src="../../assets/images/icon-add.png"
               class="icons-add-contact"><span>添加随访人</span></a>
      </div>
    </div>
    <!--模块-->
    <div class="layout-desc-check">
      <div class="tit-desc-check color-nol">访谈记录</div>
      <textarea class="textarea-addvisit"
                placeholder="请输入访谈内容"
                v-model="visistResult"
                @click="showheigh()"></textarea>
    </div>
    <!--模块-->
    <SubmitReport :reportData="reportData"
                  v-show="submitShow"></SubmitReport>
    <van-popup v-model="popShow"
               round
               position="bottom"
               :style="{ height: '35%' }">
      <van-picker :title="popTitle"
                  show-toolbar
                  :columns="popData"
                  @confirm="onPopConfirm"
                  @cancel="hidePopup"></van-picker>
    </van-popup>

    <van-popup v-model="popMutiShow"
               round
               position="bottom"
               :style="{ height: '40%' }">
      <van-checkbox-group v-model="mutiResult"
                          @change="mutiChange()">
        <van-cell-group>
          <van-cell v-for="(item, index) in popMutiData"
                    clickable
                    :key="item.code"
                    :title="item.displayValue"
                    @click="toggle(index,item.displayValue)">
            <template #right-icon>
              <van-checkbox :name="item.code"
                            ref="checkboxes" />
            </template>
          </van-cell>
        </van-cell-group>
      </van-checkbox-group>
    </van-popup>
    <van-calendar v-model="calendarShow"
                  @confirm="onCalendarConfirm"
                  :min-date="minDate"
                  :max-date="maxDate"
                  :show-confirm="false" />
    <!--弹窗-->

  </div>
</template>

<script>
import reportModel from '../../api/model/visit-report'
import customerModel from '../../api/model/customer'
import globParamModel from '../../api/model/glob-param'
import commonModel from '../../api/model/common'
import SubmitReport from '../../components/visit-report/SubmitReport.vue'
import visitPlanModel from '../../api/model/visit-plan'
import { mapState } from 'vuex'
import { nanoid } from 'nanoid'
export default {
  name: 'CreateReport',
  props: ['planid'],
  data() {
    return {
      docmHeight: document.documentElement.clientHeight, //默认屏幕高度
      showHeight: document.documentElement.clientHeight, //实时屏幕高度

      customers: [], //客户数据
      customerId: 0, //客户ID
      customerName: '', //客户名称

      popMutiShow: false, //多选
      popMutiData: [], //多选列表数据
      mutiResult: [], //多选选择结果

      popShow: false, //是否显示POP
      popOperType: 0, //POP类型
      popTitle: '', //POP标题
      popData: [], //POP下拉数据

      visitDate: '', //访问日期显示字符串
      nextVisitDate: '', //下次访问日期显示字符串

      calendarShow: false, //是否显示日历
      calendarOperType: 0, //日历显示类型
      minDate: new Date(), //最小时间
      maxDate: new Date(), //最大时间
      reportLimit: 0, //访问报告限制天数

      visitWay: [], //访问方式
      visitWayText: '', //访问方式显示字符串
      visitWayArr: [], //访问方式下拉数组
      visitWayCode: '', //访问方式代码

      connecters: [], //联系人数据
      connecterArr: [], //联系人下拉数组
      // connecterId: 0, //联系人ID
      // connecterName: '', //联系人显示字符串

      visistResult: '', //访问结果

      visitReason: [], //访问原因数据
      visitReasonArr: [], //访问原因下拉
      visitReasonCode: '', //访问原因代码
      visitReasonTxt: '', //访问原因字符串
      visitReasonSelect: [], //访问原因选中项

      salData: [], //销售员数据
      salArr: [], //销售员下拉
      salCode: '', //销售员代码
      salTxt: '', //销售员
      salSelect: [], //销售员选中项

      submitShow: true, //是否显示提交按钮

      connAdd: 'connAdd',
      mainV: 'main',
      withV: 'with',
      //访问人
      visiters: {
        mainVisiterdata: [
          {
            tempId: nanoid(),
            name: '',
            nextDate: '',
            pos: '',
          },
        ],
        withVisiterdata: [],
        tempId: '',
        op: this.main,
      },
    }
  },
  methods: {
    init() {
      if (this.planid != 0 && this.planid != undefined) {
        this.getVisitPlanInfo()
      }
    },
    async getVisitPlanInfo() {
      var res = await visitPlanModel.getVisitPlanDetail({
        id: this.planid,
      })
      if (res.success) {
        this.customerName = res.data.custname
        this.customerId = res.data.custno
        this.salTxt = res.data.salesmanName
        this.visitDate = res.data.curvstdte
        this.visitReasonCode = res.data.vstreason
        this.visitWayCode = res.data.vstway
        this.connecterName = res.data.personname1
        this.visistResult = res.data.vstresult
        this.salCode = res.data.salemencode
        this.visiters.mainVisiterdata=[]
        res.data.visiter.mainVisiter.forEach(item=>{
          this.visiters.mainVisiterdata.push({
            tempId: nanoid(),
            name: item.name,
            nextDate: item.nextDate,
            pos: item.pos,
          },)
        })
        this.visiters.withVisiterdata=[]
        res.data.visiter.withVisiter.forEach(item=>{
          this.visiters.withVisiterdata.push({
            tempId: nanoid(),
            name: item.name,
            nextDate: item.nextDate,
            pos: item.pos,
          },)
        })
      }
      if (this.visitReasonCode == 'B') {
        this.visitReasonTxt = '了解需求'
      }
      if (this.visitReasonCode == 'D') {
        this.visitReasonTxt = '方案报价'
      }
      if (this.visitReasonCode == 'H') {
        this.visitReasonTxt = '回访'
      }
      if (this.visitReasonCode == 'J') {
        this.visitReasonTxt = '参观公司'
      }
      if (this.visitReasonCode == 'K') {
        this.visitReasonTxt = '参观老客户'
      }
      if (this.visitReasonCode == 'L') {
        this.visitReasonTxt = '客情维护'
      }
      if (this.visitReasonCode == 'N') {
        this.visitReasonTxt = '谈判协商'
      }
      if (this.visitReasonCode == 'O') {
        this.visitReasonTxt = '签约'
      }
      if (this.visitWayCode == '01') {
        this.visitWayText = '面访'
      }
      if (this.visitWayCode == '02') {
        this.visitWayText = '电话回访'
      }
      if (this.visitWayCode == '03') {
        this.visitWayText = '客户来访'
      }
      if (this.visitWayCode == '99') {
        this.visitWayText = '面访未打卡/现场开标'
      }
      if (this.visitWayCode == '04') {
        this.visitWayText = '销售'
      }
    },
    changeCustomer() {
      this.customerId = 0
      this.visiters = {
        mainVisiterdata: [
          {
            tempId: nanoid(),
            name: '',
            nextDate: '',
            pos: '',
          },
        ],
        withVisiterdata: [],
        tempId: '',
        op: this.main,
      }
    },
    async searchCustData() {
      if (this.customerName == '') {
        this.$toast('请输入客户名称关键字')
      } else {
        const res = await customerModel.getCustomerList({
          keyWord: this.customerName,
        })
        if (res.success) {
          this.customers = res.data
          this.popData = []
          this.popTitle = '客戶'
          this.customers.forEach((cust) => {
            this.popData.push('(' + cust.customerNo + ')' + cust.customerName)
          })
          this.popOperType = 0
          this.showPopup()
        } else {
          this.$toast(res.msg)
        }
      }
    },
    showMutiPopup() {
      this.popMutiShow = true
    },
    hideMutiPopup() {
      this.popMutiShow = false
    },
    toggle(index, item) {
      this.$refs.checkboxes[index].toggle()
      var selectIndex = this.visitReasonSelect.indexOf(item)
      if (selectIndex != -1) {
        this.visitReasonSelect.splice(selectIndex, 1)
      } else {
        this.visitReasonSelect.push(item)
      }
      var reasons = ''
      this.visitReasonSelect.forEach((item) => {
        reasons += item + ','
      })
      reasons = reasons.substr(0, reasons.length - 1)
      this.visitReasonTxt = reasons
    },
    mutiChange() {
      var codes = ''
      if (this.mutiResult.length > 0) {
        this.mutiResult.forEach((item) => {
          codes += item + ','
        })
        codes = codes.substr(0, codes.length - 1)
      }
      this.visitReasonCode = codes
    },
    showPopup() {
      this.popShow = true
    },
    hidePopup() {
      this.popShow = false
    },
    onPopConfirm(value, index) {
      if (this.popOperType == 0) {
        this.customerName = this.customers[index].customerName
        this.customerId = this.customers[index].customerNo
      } else if (this.popOperType == 1) {
        this.visitWayText = value
        this.visitWayCode = this.visitWay[index].code
      } else if (this.popOperType == 2) {
        // this.connecterId = this.connecters[index].id
        // this.connecterName = value
        if (this.visiters.op == this.mainV) {
          this.visiters.mainVisiterdata.forEach((item) => {
            if (item.tempId == this.visiters.tempId) {
              item.name = this.connecters[index].connectName
              item.pos = this.connecters[index].cardCode
            }
          })
        } else {
          this.visiters.withVisiterdata.forEach((item) => {
            if (item.tempId == this.visiters.tempId) {
              item.name = this.connecters[index].connectName
              item.pos = this.connecters[index].cardCode
            }
          })
        }
      } else if (this.popOperType == 3) {
        this.visitReasonTxt = value
        this.visitReasonCode = this.visitReason[index].code
      } else if (this.popOperType == 4) {
        this.salTxt = value
        this.salCode = this.salData[index].salesmanCode
      }
      this.hidePopup()
    },
    showCalendar(operType) {
      this.datacalendarOperType = operType
      var dateTime = new Date()
      if (this.datacalendarOperType == 0) {
        this.minDate = new Date(
          dateTime.getFullYear(),
          dateTime.getMonth(),
          dateTime.getDate() - this.reportLimit
        )
        this.maxDate = new Date(
          dateTime.getFullYear(),
          dateTime.getMonth(),
          dateTime.getDate()
        )
      } else if (this.datacalendarOperType == 1) {
        this.minDate = new Date(
          dateTime.getFullYear(),
          dateTime.getMonth(),
          dateTime.getDate() + 1
        )
        this.maxDate = new Date(
          dateTime.getFullYear(),
          dateTime.getMonth(),
          dateTime.getDate() + 90
        )
      }
      this.calendarShow = true
    },
    formatCalendarDate(date) {
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
    },
    onCalendarConfirm(date) {
      this.calendarShow = false
      var dateValue = this.formatCalendarDate(date)
      if (this.datacalendarOperType == 0) {
        this.visitDate = dateValue
      } else if (this.datacalendarOperType == 1) {
        //this.nextVisitDate = dateValue
        if (this.visiters.op == this.mainV) {
          this.visiters.mainVisiterdata.forEach((item) => {
            if (item.tempId == this.visiters.tempId) {
              item.nextDate = dateValue
            }
          })
        } else {
          this.visiters.withVisiterdata.forEach((item) => {
            if (item.tempId == this.visiters.tempId) {
              item.nextDate = dateValue
            }
          })
        }
      }
    },
    async getLimit() {
      const res = await reportModel.getLimit({})
      if (res.success) {
        res.data.forEach((item) => {
          if (item.vstpar_id == 1) {
            this.reportLimit = item.vstpar_value2 - 1
          }
        })
      } else {
        this.$toast(res.msg)
      }
    },
    async getVisitWay() {
      const res = await globParamModel.getVisitWay({})
      if (res.success) {
        this.visitWay = res.data
        this.visitWayArr = []
        this.visitWay.forEach((way) => {
          this.visitWayArr.push(way.displayValue)
        })
      } else {
        this.$toast(res.msg)
      }
    },
    showVisitWay() {
      this.popData = this.visitWayArr
      this.popOperType = 1
      this.popTitle = '访问方式'
      this.showPopup()
    },
    async getConnecters(id, op) {
      this.visiters.tempId = id
      this.visiters.op = op
      if (this.customerId == 0) {
        this.$toast('请先通过搜索确认客户后再继续此操作')
      } else {
        const res = await customerModel.getCustomerConnecterList({
          custId: this.customerId,
        })
        if (res.success) {
          this.connecters = res.data
          this.connecterArr = []
          this.connecters.forEach((item) => {
            this.connecterArr.push(item.connectName)
          })
          this.showConnecters()
        } else {
          this.$toast(res.msg)
        }
      }
    },
    showConnecters() {
      this.popData = this.connecterArr
      this.popOperType = 2
      this.popTitle = '被访者'
      this.showPopup()
    },

    async getVisitReason() {
      const res = await globParamModel.getVisitReason({})
      if (res.success) {
        this.visitReason = res.data
        this.visitReasonArr = []
        this.visitReason.forEach((item) => {
          this.visitReasonArr.push(item.displayValue)
        })
      } else {
        this.$toast(res.msg)
      }
    },
    async getMutiBranchSals() {
      const res = await commonModel.getMutiBranchSalsByName({
        salName: this.salesName,
      })
      if (res.success) {
        this.salData = res.data
        this.salArr = []
        this.salData.forEach((item) => {
          this.salArr.push(item.salesmanName)
        })
      } else {
        this.$toast(res.msg)
      }
    },
    showVisitReason() {
      //单选
      this.popData = this.visitReasonArr
      this.popOperType = 3
      this.popTitle = '访问原因'
      this.showPopup()
      //多选
      //this.popMutiData = this.visitReason
      //this.showMutiPopup()
    },
    showSal() {
      //单选
      this.popData = this.salArr
      this.popOperType = 4
      this.popTitle = '销售员'
      this.showPopup()
    },
    showheigh() {
      if (this.docmHeight > this.showHeight) {
        this.submitShow = false
      } else {
        this.submitShow = true
      }
    },
    deleteVisiter(id, op) {
      if (op == this.mainV) {
        for (
          let index = 0;
          index < this.visiters.mainVisiterdata.length;
          index++
        ) {
          if (this.visiters.mainVisiterdata[index].tempId == id) {
            this.visiters.mainVisiterdata.splice(index, 1)
            break
          }
        }
      } else {
        for (
          let index = 0;
          index < this.visiters.withVisiterdata.length;
          index++
        ) {
          if (this.visiters.withVisiterdata[index].tempId == id) {
            this.visiters.withVisiterdata.splice(index, 1)
            break
          }
        }
      }
    },
    getNextDate(id, op) {
      this.visiters.tempId = id
      this.visiters.op = op
      this.showCalendar(1)
    },
    addVisiter(op) {
      this.visiters.tempId = nanoid()
      this.visiters.op = op
      if (op == this.mainV) {
        if (this.visiters.mainVisiterdata.length >= 6) {
          this.$toast('最多只能添加6个主访人')
          return false
        }
        this.visiters.mainVisiterdata.push({
          name: '',
          nextDate: '',
          tempId: this.visiters.tempId,
        })
      } else {
        if (this.visiters.withVisiterdata.length >= 6) {
          this.$toast('最多只能添加6个随访人')
          return false
        }
        this.visiters.withVisiterdata.push({
          name: '',
          nextDate: '',
          tempId: this.visiters.tempId,
        })
      }
    },
  },
  computed: {
    ...mapState('userAbout', ['salesName', 'rolePowers']),
    ...mapState('systemAbout', ['RoleType']),
    reportData() {
      const reportData = {
        custId: this.customerId,
        visiter: {
          mainVisiter: this.visiters.mainVisiterdata,
          withVisiter: this.visiters.withVisiterdata,
        },
        visitDate: this.visitDate,
        visitWayCode: this.visitWayCode,
        visitResult: this.visistResult,
        visitReason: this.visitReasonCode,
        salCode: this.salCode,
        conName: this.connecterName,
        planId: this.planid,
      }
      return reportData
    },
  },
  watch: {
    showHeight() {
      if (this.docmHeight > this.showHeight) {
        this.submitShow = false
      } else {
        this.submitShow = true
      }
    },
  },
  components: {
    SubmitReport,
  },
  mounted() {
    this.getLimit()
    this.getVisitWay()
    this.getVisitReason()
    this.init()
    if (this.rolePowers.indexOf(this.RoleType.mutiBranch) != -1) {
      this.getMutiBranchSals()
    }
    window.onresize = () => {
      return (() => {
        this.showHeight = document.body.clientHeight
      })()
    }
  },
}
</script>

<style scoped>
.btnCenter {
  margin: 0 auto;
  display: block;
  width: 30%;
}
</style>